module.exports = __webpack_public_path__ + "static/media/girl.bd503cd8.png";